
import Vue from 'vue'
import ContestItem from '@/components/contest/ContestItem.vue'
import ServerPaginationList from '@/components/ServerPaginationList.vue'

export default Vue.extend({
  name: 'ContestList',

  components: {
    ContestItem,
    ServerPaginationList,
  },

  props: {
    filter: {
      type: String,
    },

    projectId: {
      type: String,
    },
  },

  computed: {
    actionUrl: function (): string {
      const actions: {[key: string]: string} = {
        "finished": "/contests?status=finished&sortBy=contestFinishedAt&sortDirection=desc",
        "readyForUserApplication": "/contests?status=open&sortBy=publicFrom&sortDirection=asc",
        "coming-soon": "/contests?status=coming-soon&sortBy=publicFrom&sortDirection=asc"
      }

      return actions[this.filter] ?? "/contests?status=open&sortBy=contestFinishedAt&sortDirection=asc"
    },

    isActiveApplyContest: function (): boolean {
      return this.filter === "readyForUserApplication";
    },
  },

  data: () => ({}),
})
